import { RecentDetailPageDataOptions } from './types';

export const LIST_ITEM_ID_COOKIE_NAME = 'recentListPageItemId';
export const LIST_PAGE_TYPE_ID_COOKIE_NAME = 'recentListPageTypeId';

export const RECENT_DETAIL_PAGES_KEY = 'recentDetailPageItems';
export const DISPLAY_LIMIT = 5;
export const STORAGE_LIMIT = 10;

export const ErrorStatuses = [403, 404];

export const RecentDetailPageDataDefaultOptions: Partial<RecentDetailPageDataOptions> = {};

export const URL_PARAMS_TO_REMOVE = ['editMode', 'notificationMessage', 'listData', 'redirectUrl', 'tab'];
